module.exports = __webpack_public_path__ + "img/_kazakhstan.3b0cb2ee.png";